import React, { Component } from 'react';
import './Indirizione.css';
//import idsz from '../../images/public/registeration/idsz.png';
import clos from '../../images/public/registeration/clos.png';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
//import { BrowserView, MobileView, isBrowser } from 'react-device-detect';
import { BrowserView, MobileView } from 'react-device-detect';
import { updateUser, buyService, getCountries, getCounties, buyAnotherCard } from '../../libs/fetch'
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
import WaitLoad from "../../assets/components/loading/WaitLoad";
// import {} from '../../libs/fetch'
import Cookies from 'universal-cookie';
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
//import { Tooltip } from 'react-lightweight-tooltip';
import Cleave from 'cleave.js/react';
//import itabar2 from '../../images/public/registeration/nav2i.png';
//import engbar2 from '../../images/public/registeration/nav2e.png';
//import simplebar2 from '../../images/public/registeration/mobilenav2.png';
import miniArrow from '../../images/public/registeration/miniarrow.png';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';
import TopBar from '../../assets/components/topbar/TopBar';
import logo from '../../images/public/login/logo.png';

const cookies = new Cookies();
class Indirizione extends Component {
	constructor(props) {
		super(props);

		//let params = null;
		//console.log('[Indirizione]', params);

		this.state = {
			step: '2',
			loadedData: false,
			isLoading: false,
			errmsg: null,
			errorFlg: false,
			errorFlg2: false,
			purchaseCart: null, //the data inside strPurchaseCard is parsed and converted to object array as we want and then is stored in storage
			user: null,
			dataCheck: false,//checks if all fileds entred correctly
			nameSurname: "",
			via: "",
			citta: "",
			Provinca: "",
			Presso: "",
			Civico: "",
			Cap: "",
			Stato: "",
			fullCountryList: null,
			fullSatatesList: null,
			countryList: [],
			defaultCountry: null,
			stateList: [],
			defaultstate: null,
			isSecondCard: false,
			purchaseHere: false,
			isUpdate: false,
			canUpdate: false,
		};
	}

	componentDidMount() {
		let user = JSON.parse(localStorage.getItem('user'));
		let purchaseCart = JSON.parse(localStorage.getItem("purchaseCart"));
		let cart = JSON.parse(localStorage.getItem("cart"));
		let updateAndGoToHome = localStorage.getItem("updateAndGoToHome");
		let linkedUser = JSON.parse(localStorage.getItem('linkedUser'));
		if (linkedUser) {
				this.setState({ isSecondCard: true, purchaseHere: true });
		}
		this.setState({ user, purchaseCart, cart, linkedUser, loadedData: true });
		//console.log('[Indirizione] @updateAndGoToHome: ', updateAndGoToHome);
		//console.log('[Indirizione] @purchaseCart: ', purchaseCart);
		if (user) {
				this.setState({ nameSurname: (user.name + " " + user.surname) });
				//console.log('[Indirizione] @user: ', user);
				//console.log('[Indirizione] @userrrrrr: ', user.address2,user.street_number,user.zipcode );
				this.setState({
						Civico: user.street_number ? user.street_number : '',
						Presso: user.address2 ? user.address2 : '',
						Cap: user.zipcode ? user.zipcode : ''
				});
				this.getCountries();
				this.getCountryStates();
				this.forceUpdate(() => {
						this.addressExteractor(user);
						this.dataCheck();
						this.setState({
								isUpdate: updateAndGoToHome === 'true',
								canUpdate: this.checkIfUpdateIsPossible(user)
						})
				})
		}
    }
    checkIfUpdateIsPossible=(user)=>{
        //console.log('[Indirizione] checkIfUpdateIsPossible @user: ', user)
        //console.log("[Indirizione] checkIfUpdateIsPossible: ", this.state.nameSurname != "" , this.state.via != "" , this.state.citta != "" , this.state.Provinca != "" , this.state.Civico != "" , this.state.Cap != "" , this.state.Stato != "")
        return (!!user.name&&
            !!user.surname&&
            !!user.address&&
            !!user.street_number&&
            !!user.city&&
            !!user.zipcode&&
            !!user.country.paese&&
            !!user.province.provincia
            )
    }

    //this call is used to get list of countries in the needed format
    getCountries = () => {
			this.setState({ isLoading: true });
			let access_token = cookies.get('access_token');
			let params = {};
			let countryList = [];
			getCountries(this, access_token, params)
					.then((response) => {
							//console.log("[Indirizione] getCountries @response: ", response);
							if (response.length > 0) {
									this.setState({ fullCountryList: response });
									for (var i in response) {
											countryList.push(response[i].paese);
									}
									this.setState({ countryList: countryList.sort() });
							}
					});
    }
    //this call is used to get list of states in the needed format
    getCountryStates = () => {
			this.setState({ isLoading: true });
			let access_token = cookies.get('access_token');
			let params = {};
			let stateList = [];
			getCounties(this, access_token, params)
					.then((response) => {
							//console.log("[Indirizione] getCounties @response: ", response);
							if (response.length > 0) {
									this.setState({ fullSatatesList: response });
									for (var i in response) {
											stateList.push(response[i].provincia);
									}
									this.setState({ stateList: stateList.sort() });
							}
					});
    }

    addressExteractor(user) {
        //console.log("addressExteractor: ", user);

        if (user.address) {
            var Civico = user.address.replace(/^\D+/g, '');
            var via = user.address.replace(Civico, '');
            //console.log("address: ", via, Civico);
            this.setState({  via });
        }
        if (user.block) {
            this.setState({ Presso: user.block });
        }
        if (user.city) {
            this.setState({ citta: user.city });
        }
        if (user.country) {
            this.setState({ country: user.country, defaultCountry: user.country.paese, Stato: user.country.codepaese });
        } else {
            //defaul country set to italy
            this.setState({ defaultCountry: "Italy", Stato: "IT" });

        }
        if (user.zipcode) {
            this.setState({ Cap: user.zipcode });
        }
        if (user.province) {
            this.setState({ province: user.province, defaultstate: user.province.provincia, Provinca: user.province.sigla_provincia });
        }
    }

    gotoNextPage = (e) => {
        e.preventDefault();
        //console.log("[Indirizione] gotoNextPage");
        return this.updateUser();
    }


    //checks if all fileds entred correctly
    dataCheck() {
        if (this.state.nameSurname !== "" && this.state.via !== "" && this.state.citta !== "" && this.state.Provinca !== "" && this.state.Civico !== "" && this.state.Cap !== "" && this.state.Stato !== "")
					return this.setState({ dataCheck: true });
        return this.setState({ dataCheck: false });
    }

    //this call is used to add new Card into the purchase cart
    updateUser = () => {
        this.setState({ isLoading: true });
        let access_token = cookies.get('access_token');
        let params = {
            name: this.state.user.name,
            surname: this.state.user.surname,
            //date_of_birth: this.state.user.data_nasc,
            //fiscal_code: this.state.user.fiscal_code,
            address: this.state.via,
            street_number: this.state.Civico,
            address2: this.state.Presso,
            zipcode: this.state.Cap,
            city: this.state.citta,
            //gender: this.state.user.gender,
            province: this.state.Provinca,
            country: this.state.Stato,
            //tel_cell: this.state.user.tel_cell,
            //portal: "sci",
            //backoffice: "0",
        };
        updateUser(this, access_token, params)
            .then((response) => {
                //console.log("[Indirizione] updateUser @response: ", response);
                if (response.status === "success") {
                    if (this.state.isUpdate){
                    return this.props.history.push('/');
                }
                    return this.buyService();
                } else {
                    //fail
                    this.setState({
                        errorFlg: true,
                        errmsg: response.message
                    });
                }
            });
        return
    }


    purchaseSuccess = (response) => {
        /*
        if the error message is something else than credit card error, 
        the purchase was successfull and user need to be noticed by post-purchase messages i.e. need for card activation, etc.
        After user confirms(pressed OK), will be redirected to the next screen.
        */
        if (response.status.indexOf('fail') != -1) {
            this.setState({
                errorFlg2: true,
                errmsg: response.message
            });
        } else return this.props.history.push('/Acquistuato');//if there is no error: 'success' case.
    }


    //this call is used to add new Card into the purchase cart
    buyService = () => {
        if (this.state.isSecondCard) {
            //here we don't need to check checkIfCanBuyCard
            return this.buyAnotherCard();
        }
        this.setState({ isLoading: true });
        let access_token = cookies.get('access_token');
        // let confirmedvoucher_code = cookies.get('confirmedvoucher_code');
        let vc = JSON.parse(localStorage.getItem("confirmedvoucher_code"));
        let confirmedvoucher_code = vc ? vc.v_code ? vc.v_code : '' : '';

        let params = {
            portal: 'sci',
            voucher_code: confirmedvoucher_code
        };
        buyService(this, access_token, params)
            .then((response) => {
                //console.log("[Indirizione] buyService @response: ", response);
                if (response.status === 'fail_credit_card') {
                    //fail: user has no credit card associated, she must insert creditcard info
                    return this.props.history.push('/Insericredito');
                } else {
                    return this.purchaseSuccess(response);
                }
            });
        return
    }

    _onSelectContry = (value) => {
        //console.log("[Indirizione] _onSelectContry: ", value.value);

        this.setState({ defaultCountry: value.value });
        for (var i in this.state.fullCountryList) {
            // console.log("[Indirizione] fullCountryList: ",this.state.fullCountryList[i].paese);
            if (this.state.fullCountryList[i].paese === value.value) {
                this.setState({ Stato: this.state.fullCountryList[i].codepaese });
            }
        }
        this.forceUpdate(() => {
            if (this.state.Stato != "IT") {
                this.setState({ noStates: true, defaultstate: "--", Provinca: "( )" });
            } else {
                this.setState({ noStates: false, defaultstate: tr.t("Province"), Provinca: "" });
            }
            this.forceUpdate(() => {
                this.dataCheck();
            })
        })
    }

    _onSelectState = (value) => {
        //console.log("[Indirizione] _onSelectState: ", value);
        this.setState({ defaultstate: value.value });
        for (var i in this.state.fullSatatesList) {
            if (this.state.fullSatatesList[i].provincia === value.value) {
                this.setState({ Provinca: this.state.fullSatatesList[i].sigla_provincia });
            }
        }
        this.forceUpdate(() => {
            this.dataCheck();
        })
    }

    onChangeAddressInfo = (e) => {
        e.preventDefault();
        //console.log("[Indirizione] onChangeAddressInfo: ", e.target.name, e.target.value);
        this.setState({canUpdate: false});
        switch (e.target.name) {
            // case "fillname":
            //     this.setState({ nameSurname: e.target.value });
            //     break;
            case "street":
                this.setState({ via: e.target.value });
                break;
            case "city":
                this.setState({ citta: e.target.value });
                break;
            // case "Provinca":
            //     this.setState({ Provinca: e.target.value });
            //     break;
            case "at":
                this.setState({ Presso: e.target.value });
                break;
            case "streetnum":
                this.setState({ Civico: e.target.value });
                break;
            case "postcode":
                this.setState({ Cap: e.target.value });
                break;
            // case "Stato":
            //     this.setState({ Stato: e.target.value });
            //     break;

            default:
                break;
        }
        this.forceUpdate(() => {
            this.dataCheck();
        })
    }

    //this call is used for purchasing second card for the same user
    buyAnotherCard = () => {
        this.setState({ isLoading: true });
        let linkedUser = this.state.linkedUser;
        let access_token = cookies.get('access_token');
        let params = {
            linked_user_id: linkedUser.id,
            provider: linkedUser.provider.toLowerCase() === "skidata" ? "axess" : "skidata",
            // type: linkedUser.type, //According to @Veronica type should be changed to on of new, renew, second_card
            type: 'second_card',
            code: this.state.cart.cardNumber,
            shipment: '1',//1 for card to be shipped,otherwise 0
        };
        buyAnotherCard(this, access_token, params)
            .then((response) => {
                this.setState({ isLoading: false });
                //console.log("[Ritirocard] buyAnotherCard @response: ", response);
                if (response.status === "success") {
                    return this.props.history.push('/');
                } else {
                    this.setState({
                        errorFlg: true,
                        errmsg: response.message
                    });
                }
            });
    }

    alertResponse(info) {
        switch (info.type) {
            case "closeButton":
                this.setState({ errorFlg: false })
                break;
            case "actionButton":
                if (info.option1 === "attention") {
                    this.setState({ errorFlg: false })
                    break;
                }
                if (info.option1 === "errorPurchase") {
                    this.setState({ errorFlg2: false })
                    return this.props.history.push('/Acquistuato');
                }
        }
    }

    render() {
			//consconsole.log('[Indirizione]', this.state);
			return (
				<Router>
					<div>
						<div>
							<BrowserView>
								<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
									<div className="row flex-nowrap">
										<div className="col-2 d-flex align-items-center">
											{/*<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>*/}
										</div> 
										<div className="col-8 d-flex align-items-center justify-content-center">
											<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
										</div>
										<div className="col-2 d-flex align-items-center justify-content-end">
											<div className="sn_exit">
												<a onClick={() => { return this.props.history.push('/') }}>
													<img src={ clos } alt=""/>
												</a>
											</div>
										</div>
									</div>
								</div>
								<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
								<div className="sn_overlay d-lg-none"></div>
								<div className="sn_ind">
									<div className="container">
										<div className="row">
											<div className="col-12 col-lg-9 mx-auto">
												<div className="sn_register__container p-3 p-md-4 p-lg-5 overflow-visible">
													<div className="row d-none d-lg-flex">
														<div className="col-12 d-flex justify-content-end">
															<div className="sn_exit">
																<a onClick={() => { return this.props.history.push('/') }}>
																	<img src={clos} alt=""/>
																</a>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-12">
															<div className="sn_title mb-2">
																{tr.t("Shipadd")}
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-12">
															<div className="text-center mb-5">
																{tr.t("Bypriority")}
																&#160;
																<strong className="txlsizBold">
																{tr.t("Fourdays")}
																</strong>.
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-12 col-md-6 mb-35 mb-sm-50">
															<input type="text" disabled={true} name="fullname" placeholder={tr.t("Fullnameinput")} defaultValue={this.state.nameSurname} className="sn_input" maxLength="50" onChange={this.onChangeAddressInfo} />
														</div>
														<div className="col-12 col-md-6 mb-35 mb-sm-50">
															<input type="text" name="at" placeholder={tr.t("At")} className="sn_input" maxLength="50" defaultValue={this.state.Presso} onChange={this.onChangeAddressInfo} />
														</div>
													</div>
													<div className="row">
														<div className="col-12 col-md-6 mb-35 mb-sm-50">
															<input type="text" name="street" placeholder={tr.t("Street")} className="sn_input" maxLength="50" defaultValue={this.state.via} onChange={this.onChangeAddressInfo} />
														</div>
														<div className="col-12 col-md-6 mb-35 mb-sm-50">
															<Cleave
																className="sn_input"
																options={ {blocks: [10], numericOnly: true} }
																onChange={this.onChangeAddressInfo}
																placeholder={tr.t("Streetnum")}
																value={this.state.Civico}
																name="streetnum"
															/>
														</div>
													</div>
													<div className="row">
														<div className="col-12 col-md-6 mb-35 mb-sm-50">
															<input type="text" name="city" placeholder={tr.t("City")} className="sn_input" maxLength="50" defaultValue={this.state.citta} onChange={this.onChangeAddressInfo} />
														</div>
														<div className="col-12 col-md-6">
															<Cleave
																className="sn_input"
																options={ {blocks: [10], numericOnly: true} }
																onChange={ this.onChangeAddressInfo }
																placeholder={ tr.t("Postalcode") }
																value={ this.state.Cap }
																name="postcode"
															/>
														</div>
													</div>
													<div className="row mb-5">
														<div className="col-12 col-md-6 d-flex justify-content-center">
															<div className="w-100 t_dropdown">
																<Dropdown 
																	disabled={this.state.noStates}
																	name="province"
																	options={this.state.stateList}
																	onChange={(value) => this._onSelectState(value)}
																	value={this.state.defaultstate}
																	placeholder={tr.t("Province")}
																	arrowClassName={'myArrowClassName'}
																	menuClassName={'sn_ind__dropdown__menu'}
																	controlClassName={'sn_ind__dropdown'}
																/>
															</div>
														</div>
														<div className="col-12 col-md-6 d-flex justify-content-center"> 
															<div className="w-100 t_dropdown">
																<Dropdown name="country" options={this.state.countryList}
																	onChange={(value) => this._onSelectContry(value)}
																	value={this.state.defaultCountry}
																	placeholder={tr.t("Country")}
																	arrowClassName={'myArrowClassName'}
																	menuClassName={'sn_ind__dropdown__menu'}
																	controlClassName={'sn_ind__dropdown'}
															/>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-12 d-flex justify-content-center">
															<div className="sn_container__button">
																<button disabled={!(this.state.dataCheck || this.state.canUpdate)} className="sn_btn" onClick={this.gotoNextPage}>{this.state.isUpdate ?tr.t('Edit') :this.state.purchaseHere ? tr.t("Purchase") : tr.t("Next")}</button>
															</div>
														</div>
													</div>
													<div className="row d-lg-none mt-5">
														<div className="col-12">
															<ProgressBullets step={ this.state.step } />
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>        
								</div>
              </BrowserView>
							<MobileView>
								<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
									<div className="row flex-nowrap">
										<div className="col-2 d-flex align-items-center">
											<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow } alt=""/></button>
										</div>
										<div className="col-8 d-flex align-items-center justify-content-center">
											<img className="sn_mobile_top_row_logo" src={ logo } alt=""/>
										</div>
									</div>
								</div>
								<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
								<div className="sn_overlay d-lg-none"></div>
								<div className="sn_ind">
									<div className="container">
										<div className="row">
											<div className="col-12 col-lg-9 mx-auto">
												<div className="sn_register__container p-3 p-md-4 p-lg-5 overflow-visible">
													<div className="row">
														<div className="col-12 d-flex justify-content-end">
															<div className="sn_exit">
																<a onClick={() => { return this.props.history.push('/') }}>
																	<img src={clos} alt=""/>
																</a>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-12">
															<div className="sn_title mb-2">
																{tr.t("Shipadd")}
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-12">
															<div className="sn_subtext text-center mb-5">
																{tr.t("Bypriority")}
																&#160;
																<strong className="txlsizBold">
																{tr.t("Fourdays")}
																</strong>.
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-12 col-md-6 mb-35 mb-sm-50">
															<input type="text" disabled={true} name="fullname" placeholder={tr.t("Fullnameinput")} defaultValue={this.state.nameSurname} className="sn_input" maxLength="50" onChange={this.onChangeAddressInfo} />
														</div>
														<div className="col-12 col-md-6 mb-35 mb-sm-50">
															<input type="text" name="at" placeholder={tr.t("At")} className="sn_input" maxLength="50" defaultValue={this.state.Presso} onChange={this.onChangeAddressInfo} />
														</div>
													</div>
													<div className="row">
														<div className="col-12 col-md-6 mb-35 mb-sm-50">
															<input type="text" name="street" placeholder={tr.t("Street")} className="sn_input" maxLength="50" defaultValue={this.state.via} onChange={this.onChangeAddressInfo} />
														</div>
														<div className="col-12 col-md-6 mb-35 mb-sm-50">
															<Cleave
																className="sn_input"
																options={ {blocks: [10], numericOnly: true} }
																onChange={this.onChangeAddressInfo}
																placeholder={tr.t("Streetnum")}
																value={this.state.Civico}
																name="streetnum"
															/>
														</div>
													</div>
													<div className="row">
														<div className="col-12 col-md-6 mb-35 mb-sm-50">
															<input type="text" name="city" placeholder={tr.t("City")} className="sn_input" maxLength="50" defaultValue={this.state.citta} onChange={this.onChangeAddressInfo} />
														</div>
														<div className="col-12 col-md-6">
															<Cleave
																className="sn_input"
																options={ {blocks: [10], numericOnly: true} }
																onChange={ this.onChangeAddressInfo }
																placeholder={ tr.t("Postalcode") }
																value={ this.state.Cap }
																name="postcode"
															/>
														</div>
													</div>
													<div className="row mb-5">
														<div className="col-12 col-md-6 d-flex justify-content-center">
															<div className="w-100 t_dropdown">
																<Dropdown 
																	disabled={this.state.noStates}
																	name="province"
																	options={this.state.stateList}
																	onChange={(value) => this._onSelectState(value)}
																	value={this.state.defaultstate}
																	placeholder={tr.t("Province")}
																	arrowClassName={'myArrowClassName'}
																	menuClassName={'sn_ind__dropdown__menu'}
																	controlClassName={'sn_ind__dropdown'}
																/>
															</div>
														</div>
														<div className="col-12 col-md-6 d-flex justify-content-center"> 
															<div className="w-100 t_dropdown">
																<Dropdown name="country" options={this.state.countryList}
																	onChange={(value) => this._onSelectContry(value)}
																	value={this.state.defaultCountry}
																	placeholder={tr.t("Country")}
																	arrowClassName={'myArrowClassName'}
																	menuClassName={'sn_ind__dropdown__menu'}
																	controlClassName={'sn_ind__dropdown'}
															/>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-12 d-flex justify-content-center">
															<div className="sn_container__button">
																<button disabled={!(this.state.dataCheck || this.state.canUpdate)} className="sn_btn" onClick={this.gotoNextPage}>{this.state.isUpdate ?tr.t('Edit') :this.state.purchaseHere ? tr.t("Purchase") : tr.t("Next")}</button>
															</div>
														</div>
													</div>
													<div className="row d-lg-none mt-5">
														<div className="col-12">
															<ProgressBullets step={ this.state.step } />
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>        
								</div>
							</MobileView>
							{
								this.state.errorFlg ?
								<div className="containerModal">
								{
									this.state.errorFlg ?
									<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
								}
								</div> : null
							}
							{
								this.state.errorFlg2 ?
								<div className="containerModal">
								{
									this.state.errorFlg2 ?
									<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"errorPurchase"} closehide = {true} callback={this.alertResponse.bind(this)} /> : null
								}
								</div> : null
							}                        
						</div>
						<WaitLoad enable={this.state.isLoading} />
					</div>
				</Router>
		);
	}
}

export default Indirizione;


// WEBPACK FOOTER //
// ./src/screens/Indirizione/Indirizione.js